import classNames from 'classnames';
import IcExclamationCircle from '@/assets/icons/ExclamationCircle.svg?react';
import styles from './FormError.module.scss';

interface FormErrorProps {
  className?: string;
  id?: string;
  isRoot?: boolean;
  message: string;
}

const FormError = ({ className, id, isRoot, message }: FormErrorProps) => (
  <div
    id={id}
    className={classNames(
      styles.formError,
      {
        [styles.isRoot]: isRoot,
      },
      className
    )}
  >
    {isRoot && <IcExclamationCircle className={styles.icon} />}
    {message}
  </div>
);
export default FormError;
